<template>
  <el-row>
    <el-col>
      <el-menu
        :router="routerMode"
        class="el-menu-vertical-demo full-height"
        background-color="#fff"
        text-color="#000"
        :default-active="activeIndex"
        :collapse-transition="true"
        :unique-opened="true"
      >
        <slot name="trademark" />
        <slot name="router" />
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      routerMode: true
    };
  },
  computed: {
    ...mapState(["activeIndex"])
  }
};
</script>

<style scoped>
.full-height {
  height: 100vh;
}

.el-menu {
  overflow: hidden;
  overflow-y: auto;
}
</style>
